import { Box, Table, Tbody, VStack } from '@chakra-ui/react';
import { OrderWithDeliveryOrders } from '@diamond/shared/types';
import { LIST_FEATURE_FLAGS, useFeatureFlag } from '@diamond/shared/utils';
import {
  BindedPromoData,
  BundledDiscountPromo,
  SingleDiscountPromo,
} from '@diamond/sol-buyer/utils';
import { Fragment, ReactNode } from 'react';

import { DivisionDivider } from './division-divider';
import { ProductRow } from './product-row/product-row';
import { ProductTableHeader } from './product-table-header';

type ProductTableProps = {
  data: BindedPromoData;
  isSubmitted?: boolean;
  extra?: ReactNode;
  deliveryOrders?: OrderWithDeliveryOrders[];
};

export function ProductTable({
  data,
  isSubmitted,
  extra,
  deliveryOrders,
}: ProductTableProps) {
  const isVoucherMenuEnabled = useFeatureFlag(
    LIST_FEATURE_FLAGS.FF_VOUCHERS_MENU,
    true
  );

  return (
    <VStack align="stretch">
      <Box>
        <Table>
          <ProductTableHeader />
          <Tbody>
            {data.map((item, divIdx: number) => {
              const bundledCashbacks =
                item.promos.bundled_discount_promos.filter(
                  (promo: BundledDiscountPromo) => !promo.is_discount
                );
              const singleCashbacks = item.promos.single_discount_promos.filter(
                (promo: SingleDiscountPromo) => !promo.is_discount
              );
              const cashbacks = [...singleCashbacks, ...bundledCashbacks];

              const matchingDeliveryOrder = deliveryOrders?.find(
                (do_) => do_.division === item.divider
              );

              return (
                <Fragment key={`division-${divIdx}`}>
                  <DivisionDivider
                    division={item}
                    isSubmitted={isSubmitted}
                    divIdx={divIdx}
                    deliveryOrder={matchingDeliveryOrder}
                  />
                  {item.products.map((product, idx) => (
                    <ProductRow
                      key={`product-row-${divIdx}-${idx}`}
                      product={product}
                      isVoucherMenuEnabled={isVoucherMenuEnabled}
                      divIdx={divIdx}
                      productIdx={idx}
                    />
                  ))}
                </Fragment>
              );
            })}
          </Tbody>
        </Table>
        {extra}
      </Box>
    </VStack>
  );
}
